import { apiGet } from "./utils";

export interface IngestionLog {
  id: string;
  agentPlatform: string;
  category: string;
  status: "pending" | "completed" | "failed";
  errorMessage: string | null;
  ingestedFrom: string;
  ingestedTo: string;
  createdAt: string;
  updatedAt: string;
}

export const ingestionLogsApi = {
  getInitialPull: async (): Promise<IngestionLog[]> => {
    return apiGet<IngestionLog[]>(
      "/api/v1/agent_platform_ingestion_logs?category=initial_pull"
    );
  },
};
